export default __webpack_public_path__ + "static/31-74fcf37d155f7abad3d6215e071fd08a.png";